import EventBus from '@/EventBus';
import config from '../config';
import sanitizeHtml from 'sanitize-html';
import menuRoutes from './shared/menuMap';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import currencies from './constants/currency';
import { getDecodedComment } from './helpers/commentHelpers';
import { dateConstants, dateMethods } from '@/helpers/dateHelper';
var some = require('lodash.some');
export default {
  data() {
    return {
      // magic numbers defined here
      escapeKeyCode: 27,
      snackbarDefaultTimeout: 5000,
      millisecondsInSecond: 1000,
      defaultProjectStartYear: 1990,
      defaultProjectStartDate: '1990-01-01',
      allOrgs: {},
      defaultTruncateLength: 8,
      ...dateConstants
    };
  },
  methods: {
    ...mapActions('userInfo', ['SET_USER_MAP', 'SET_USER_MAP_NOT_IN_SYSTEM']),
    ...mapGetters('discovery', ['getOpenProjects']),
    ...mapGetters(['connectorList']),
    ...mapMutations('discovery', ['setOpenProjects']),
    ...mapMutations([
      'setAllOrgFlattened',
      'setCustomer',
      'setAxiosSource',
      'setIsCurrentOrgLegacy'
    ]),
    ...mapMutations('notifications', ['setNotiClientToken']),
    ...mapMutations([
      'setSingleSignOnStatus',
      'setActiveConnectors',
      'setCurrentTimeZone',
      'setGlobalNav',
      'setCurrentOrgData'
    ]),
    ...dateMethods,
    renderDecodedComment(comment) {
      return getDecodedComment(comment);
    },
    cancelAxiosRequest() {
      this.setAxiosSource();
    },

    titleCase: function(str) {
      let data = '';
      if (str === '' || str === undefined) {
        data = '';
      } else {
        str = str.replace(/_/g, ' ');
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        data = splitStr.join(' ');
      }
      return data;
    },
    /**
     *
     * @param {String} userName
     * @param {Boolean} isTeamsArchive , flag to denote teams archives
     * @returns user name initials, input = 'Albert Einstein' then output --> 'AE'
     */
    getUserNameInitials(userName, isTeamsArchive) {
      // if isTeamsArchive = true, then :- first remove (External) label then get acronym
      const modifiedUserName = isTeamsArchive
        ? userName.replace('(External)', '')
        : userName;

      const acronym = modifiedUserName
        .split(' ')
        .reduce((res, word) => (res += word.slice(0, 1)), '');
      return acronym;
    },
    truncate(item, len = this.defaultTruncateLength) {
      if (item && item.length > len) {
        item = item.substring(0, len) + '...';
      }
      return item;
    },
    emailValidate(item) {
      let reg =
        // eslint-disable-next-line
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      if (reg.test(item)) {
        return true;
      } else {
        return false;
      }
    },
    validator(validationString, validatorType) {
      const regexMap = {
        // checks if a string starts with any of the special character
        // from space, hyphen or underscore
        startWith3Character: /^\s*(_|-| )/g,
        // checks if a string ends with any of the special character
        // from space, hyphen or underscore
        endsWith3Character: /.*(_|-| )$/g,
        // checks if a string contains any of the special character
        // other than space, hyphen or underscore
        // eslint-disable-next-line
        specicalCharacter: /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/g,
        // check whether domain name is valid
        validDomain: /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/
      };
      return validationString.match(regexMap[validatorType]);
    },
    getDefaultSubMenu(menu) {
      // this is only the org menu;
      menu = menu.filter(menuItem =>
        menuItem.permission
          ? this.checkPermissions(
              menuItem.permission,
              menuItem?.meta?.validateSomePermissions
            )
          : true
      );
      return menu;
    },
    /**
     *
     * @param {Array} permissions , list of permissions
     * @param {Boolean} validateSomePermissions , flag to decide action/method of validation
     * @returns {Boolean}, result of validation
     */
    checkPermissions(permissions, validateSomePermissions = false) {
      // Decide array method
      const method = validateSomePermissions ? 'some' : 'every';
      let showBillingAndPlansForLegacyOrg = true;

      /**
       * Filter permissions based on the selected organization.
       *
       * - 'dynamic' type = permissions for child organizations
       * - If own org is selected → exclude 'dynamic' permissions
       * - If child org is selected:
       *    - and 'dynamic' permissions exist → include only 'dynamic' permissions
       *    - and no 'dynamic' permissions exist → include all permissions
       */
      const hasDynamicPermissions = permissions.some(({ type }) => type === 'dynamic');

      permissions = permissions.filter(({ type }) => {
        const isOwnOrg = this.isOwnOrgSelected();

        if (isOwnOrg) {
          // Own org selected: exclude 'dynamic' permissions
          return type !== 'dynamic';
        }

        // Child org selected
        if (hasDynamicPermissions) {
          // Keep only 'dynamic' permissions
          return type === 'dynamic';
        }

        // No 'dynamic' permissions present: keep all
        return true;
      });

      // Perform validation
      const hasPermission = permissions[method](permission => {
        // For legacy orgs (or orgs having no subscription), we need to hide "Billing and Plans" tab
        if (
          this.isCurrentOrgLegacy &&
          this.$store.state.subscriptionPermissions.includes(
            `can_${permission.action}_${permission.entity}`
            )
            ) {
              showBillingAndPlansForLegacyOrg = false;
        }

        return this.$can(permission.action, permission.entity);
      });

      return showBillingAndPlansForLegacyOrg && hasPermission;
    },
    /**
     * 
     * @param {Array} permissions , array of permission details
     * @param {Boolean} validateSomePermissions , flag to decide action/method of validation
     * 
     * @returns {Boolean} hasPermission
     */
    checkPagePermission(permissions = [], validateSomePermissions = false) {
      // Decide array method
      const method = validateSomePermissions ? 'some' : 'every';

      // Perform validation
      const havePagePermission = permissions[method](({action, entity}) => this.$can(action, entity));
      if (!this.isOwnOrgSelected() && !havePagePermission) {
        this.snackbar('error', this.$message?.NO_PAGE_VIEW_PERMISSION);
        this.$router.go(-1);
        return false;
      }

      return true;
    },
    getMenuData() {
      let mainRoutes = menuRoutes
        .filter(menu => menu.parent)
        .filter(menu =>
          menu.permission
            ? this.checkPermissions(
                menu.permission,
                menu?.meta?.validateSomePermissions
              )
            : true
        )
        .map(menu => ({
          ...menu,
          children: this.getDefaultSubMenu(this.validateSubMenu(menu.children))
        }))
        .filter(menu => menu.children.length);

      return mainRoutes;
    },
    validateSubMenu(subMenus) {
      return subMenus.filter(subMenu => subMenu.link);
    },
    getServiceURL(key) {
      return config[key];
    },
    /**
     * remove underscore from array of strings
     * @param {Array<any>} arr
     */
    removeUnderscore(arr) {
      arr.forEach(ele => {
        ele.val = ele.val.replace(/_/g, ' ');
      });
      return arr;
    },
    async getOrgListData(selectedSort = 'name', sortOrder = 'ASC') {
      let orgList = await this.$services.user.getUserInfo('childOrgs', {
        orgId: this.orgId,
        params: { sortBy: selectedSort, sortOrder: sortOrder }
      });
      orgList = orgList.data;
      let orgListData = orgList.body[0].response;
      this.processOrgData(orgListData);
      return orgList;
    },
    processOrgData(orgData) {
      let allData = this.flattenData(orgData);
      this.setAllOrgFlattened(allData);
    },
    flattenData(orgs) {
      this.allOrgs[orgs.orgId] = orgs.organisationName;
      if (orgs.children) {
        for (var i = 0; i < orgs.children.length; i++) {
          this.flattenData(orgs.children[i]);
        }
      }
      return this.allOrgs;
    },
    getOrgNameById(orgId) {
      if (
        !Object.keys(this.$store.state.allOrgFlattened).length &&
        this.$can('view', 'child_organisation_details')
      ) {
        this.getOrgListData();
      }
      return this.$store.state.allOrgFlattened[orgId];
    },
    snackbar(type, message, timeout = this.snackbarDefaultTimeout) {
      let errorMessage;
      const errorDetails = message?.response?.data?.errors?.[0];
      if (errorDetails) {
        errorMessage = `${errorDetails?.errorField}: ${errorDetails?.message}`;
      } else {
        errorMessage =
          message?.message === 'Network Error'
            ? this.$message.TECHNICAL_ERROR
            : message;
      }
      EventBus.$emit('ACTIVATE_SNACKBAR', {
        visible: true,
        message: errorMessage,
        context: type,
        timeout: timeout
      });
    },
    getEmailList(arr) {
      return arr && arr.length ? arr.join(', ') : '-';
    },
    /**
     *
     * @param {Array<any>} array
     */
    copyArray(array) {
      return JSON.parse(JSON.stringify(array));
    },
    /**
     *
     * @param {String} type tells where to look, in params or queryParams
     * @param {String} paramName name of param
     * @param defaultValue use default value if param not present in route path
     * @param {Boolean} returnInt return value converted into int or as it is
     *
     * @returns value of required param/ Query param
     */
    getRouteParamValue(type, paramName, defaultValue, returnInt = false) {
      const paramValue = this.$route?.[type]?.[paramName];
      if (paramValue) {
        return returnInt ? parseInt(paramValue, 10) : JSON.parse(paramValue);
      }
      return defaultValue;
    },
    formatUserName(element) {
      return [
        (element && element.firstName) || '',
        (element && element.lastName) || ''
      ]
        .filter(Boolean)
        .join(' ');
    },
    formatFullName(element) {
      return [
        (element && element.firstName) || '',
        (element && element.middleName) || '',
        (element && element.lastName) || ''
      ]
        .filter(Boolean)
        .join(' ');
    },
    checkOwner(projectOwnerId) {
      return projectOwnerId === localStorage.getItem('userId');
    },
    checkIfApproved(arr) {
      let userObject = JSON.parse(localStorage.getItem('userData'));
      let userIndex = some(arr, item => {
        return (
          item.approverId === userObject.preferred_username &&
          item.decision === 'APPROVE'
        );
      });
      return userIndex;
    },
    getUserIds(arr) {
      let ids = [];
      let sortedArr = this.getAllIds(arr);
      sortedArr.forEach(item => {
        if (!this.userIdNameMap.hasOwnProperty(item)) {
          ids.push(item);
        }
      });
      return ids;
    },
    getAllIds(obj) {
      let ids = [];
      if (Array.isArray(obj)) {
        obj.forEach(item => {
          setIds(item);
        });
      } else {
        setIds(obj);
      }
      function setIds(item) {
        if (item.owner) {
          ids.push(item.owner);
        }
        if (item.approvedBy && item.approvedBy.length > 0) {
          ids = [...ids, ...item.approvedBy];
        }
        if (item.approverId) {
          ids.push(item.approverId);
        }
        if (item.userId) {
          ids.push(item.userId);
        }
        if (item.approvers && item.approvers.length > 0) {
          ids = [...ids, ...item.approvers];
        }
        if (item.includedUsers && item.includedUsers.length > 0) {
          ids = [...ids, ...item.includedUsers];
        }
        if (item.excludedUsers && item.excludedUsers.length > 0) {
          ids = [...ids, ...item.excludedUsers];
        }
      }
      return new Set(ids);
    },
    async getUserSubscription(type = 'SET_SUBSCRIPTIONS') {
      try {
        const subscriptionDetails = await this.$services.billing.getSubscriptions();
        const subscriptionData = this.parseResponse(subscriptionDetails);
        if (subscriptionData) {
          const data = subscriptionData?.[0]?.[0] || {};
          if (type === 'SET_BOTH') {
            this.$store.dispatch('SET_SUBSCRIPTIONS', {
              ...this.subscriptions,
              ...data,
              currencySymbol: this.getCurrencySymbol(data?.currency)
            });
            this.$store.dispatch('SET_CURRENT_SUBSCRIPTION', {
              ...this.currentSubscription,
              ...data,
              currencySymbol: this.getCurrencySymbol(data?.currency)
            });
          } else {
            this.$store.dispatch(type, {
              ...this.subscriptions,
              ...data,
              currencySymbol: this.getCurrencySymbol(data?.currency)
            });
          }
        }
      } catch (error) {
        this.snackbar('error', error);
        this.$store.dispatch(type, {});
      }
    },
    isTrialPlan() {
      return this.subscriptions?.productHandle === 'trial';
    },
    // returns true if trial ended else returns false
    isTrialEnded() {
      const subscriptionData = this.subscriptions;
      if (
        this.isTrialPlan() &&
        subscriptionData?.trialEndedAt &&
        new Date() > new Date(subscriptionData?.trialEndedAt)
      ) {
        return true;
      }
      return false;
    },
    // To get currency symbol acc to currency name
    getCurrencySymbol(currencyName) {
      const currencyObj = currencies.find(
        value => value.currencyName === currencyName
      );
      return currencyObj?.currencySymbol || '';
    },
    async getCurrentOrganisationDetails() {
      try {
        const orgDetailsResponse = await this.$services.user.getUserOrg(
          this.currentlySelectedOrgId
        );
        const orgDetails = orgDetailsResponse?.data?.body[0]?.organisation;
        const onboardingThroughMailsphere = orgDetails.organisationCustomData.find(
          customData => customData?.key === 'onboardingThroughMailsphere'
        );
        this.setIsCurrentOrgLegacy(!onboardingThroughMailsphere);
        this.setCurrentOrgData(orgDetails);
        return orgDetails;
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    async onOrgChange() {
      // get organisation details only when user have can_view_organisation permission
      if (this.$can('view', 'organisation')) {
        await this.getCurrentOrganisationDetails();
      }
      // checking for subscribed orgs and permission can_manage_subscription || can_view_subscription
      if (
        !this.isCurrentOrgLegacy &&
        (this.$can('view', 'subscription') ||
          this.$can('manage', 'subscription'))
      ) {
        await this.getUserSubscription('SET_BOTH');
      }
      await this.setSsoStatus('setStore');
      await this.connectorStatus('setStore');
      await this.getTimezone();
      this.setGlobalNav(this.getMenuData());
    },
    async connectorStatus(type, orgId) {
      const {
        data: { success, body }
      } = await this.$services.preferences.getPreferencesByPreferenceKey(
        this.$preference.ARCHIVE_TOOL_BOX_SUBSCRIPTIONS,
        null,
        orgId
      );
      if (success) {
        const {
          0: { results }
        } = body;
        if (type === 'setStore') {
          this.setActiveConnectors(results);
        }
        return results;
      }
    },
    /**
     * Funtion:- To get all connectors source details
     * @returns {success, results}, results contains array of connector source details
     */
    async getConnectorsSourceDetails() {
      let allConnectorsSourceDetails = this.connectorList();

      // If connectorList = [] in store, call API to save data in store
      // else don't call API, use connectorList from store
      if (!allConnectorsSourceDetails.length) {
        try {
          const {
            data: { success, body }
          } = await this.$services.preferences.getPreferencesByPreferenceKey(
            this.$preference.ARCHIVE_TOOL_BOX_SOURCES
          );

          if (success) {
            const {
              0: { results }
            } = body;
            allConnectorsSourceDetails = results;
            this.$store.dispatch('SET_CONNECTORS_SOURCE_DETAILS', results);
          }
        } catch (error) {
          this.snackbar('error', error);
          return {
            success: false,
            results: []
          };
        }
      }

      return {
        success: true,
        results: allConnectorsSourceDetails
      };
    },
    async setSsoStatus(type) {
      const {
        data: { success, body }
      } = await this.$services.preferences.getPreferencesByPreferenceKey(
        this.$preference.SINGLE_SIGN_ON_STATUS
      );

      if (success) {
        const {
          0: {
            results: {
              0: {
                id,
                data: {
                  status: { HAS_CONSENT }
                }
              }
            }
          }
        } = body;
        if (type === 'setStore') {
          this.setSingleSignOnStatus({ id, HAS_CONSENT });
        }
        return { id, HAS_CONSENT };
      }
    },
    async addUserDetails(val) {
      const result = val.reduce(
        (res, item) => {
          if (item === 'serviceaccount') {
            res.removedUsers.push(item);
            return res;
          }
          if (item) {
            res[
              item.startsWith('idNotInSystem') ? 'removedUsers' : 'users'
            ].push(item);
          }
          return res;
        },
        { removedUsers: [], users: [] }
      );

      if (result.users.length) {
        this.SET_USER_MAP_NOT_IN_SYSTEM(result.removedUsers);
        let users = await this.$services.user.userDetailMap(result.users);
        this.SET_USER_MAP(users);
      }
    },
    approvedByName(arr) {
      let resultArray = arr.map(elm => {
        return this.formatFullName(this.userIdNameMap[elm] || 'N/A');
      });
      if (typeof arr === 'object') {
        return resultArray.join(', ');
      } else {
        return resultArray;
      }
    },
    getNameFromId(arr) {
      let temp = [];
      if (arr.length > 0) {
        temp = arr.map(elm => {
          return this.formatFullName(this.userIdNameMap[elm] || 'N/A');
        });
      }
      return temp;
    },
    isAllowed() {
      return false;
    },
    refreshToken(minValidity) {
      let self = this;
      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        self.$keycloak
          .updateToken(minValidity)
          .success(function(data) {
            resolve(data);
          })
          .error(function(err) {
            if (err) {
              self.snackbar('error', self.$message.SESSION_EXPIRED);
              self.setOpenProjects([]);
              let selectedTheme = localStorage.getItem('selectedTheme');
              localStorage.clear();
              localStorage.setItem('selectedTheme', selectedTheme);
              self.$keycloak.logout({ redirectUri: config.baseUrl });
            }
          });
      });
    },
    getHeaders() {
      return {
        Authorization: `Bearer ${this.$keycloak.token}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      };
    },
    canViewTeams(sourceId) {
      return sourceId === this.$enums.O365_CONNECTORS.teams.connectorId
        ? this.$can('view', 'teams')
        : true;
    },

    /**
     * Maps the value based on availableName for connector
     * The @prop availableNames is a variable key object
     * depending upon the connectorType
     * @param {string} connectorType
     * @param {string} get
     * The get param is to get archiveData
     * It supports get menu and connectorData
     */

    connectorArchiveNameMap(
      connectorType,
      get = null,
      type = 'activeConnectors'
    ) {
      const connectorTypes = {
        o365_onedrive: 'onedrive',
        ONEDRIVE: 'onedrive',
        o365_sharepoint: 'sharepoint',
        SHAREPOINT: 'sharepoint',
        o365_group: 'group',
        GROUP: 'group',
        o365_teams: 'teams',
        TEAMS: 'teams',
        DROPBOX: 'dropbox',
        dropbox: 'dropbox'
      };
      const availableNames = {
        onedrive: {
          title: 'One Drive',
          id: 'o365_onedrive',
          link: '/archive-search/vault/connector/' + 'ONEDRIVE/'
        },
        sharepoint: {
          title: 'Share Point',
          id: 'o365_sharepoint',
          link: '/archive-search/vault/connector/' + 'SHAREPOINT/'
        },
        group: {
          title: 'Group',
          id: 'o365_group',
          link: '/archive-search/vault/connector/' + 'GROUP/'
        },
        teams: {
          title: 'Teams',
          id: 'o365_teams',
          link: '/archive-search/vault/connector/' + 'TEAMS/'
        },
        dropbox: {
          title: 'Dropbox',
          id: 'dropbox',
          link: '/archive-search/vault/connector/' + 'DROPBOX/'
        }
      };
      if (get) {
        const menu = [];
        const consentMenu = [];
        const connectorDataConsent = [];
        this.$store.state[type].forEach(activeConnector => {
          const {
            data: {
              subscriptionDetails: { SOURCE_ID }
            }
          } = activeConnector;
          if (
            activeConnector &&
            activeConnector.data.subscriptionDetails.HAS_CONSENT &&
            SOURCE_ID !== 'o365_group' &&
            !this.$enums.exportableConnectors.includes(SOURCE_ID) &&
            SOURCE_ID !== 'o365_email' &&
            this.canViewTeams(SOURCE_ID)
          ) {
            if (activeConnector.data.subscriptionDetails.ONBOARD_COMPLETE) {
              menu.push(availableNames[connectorTypes[SOURCE_ID]]);
              connectorDataConsent.push(activeConnector);
            }
            consentMenu.push(availableNames[connectorTypes[SOURCE_ID]]);
          }
        });
        if (get === 'menu') {
          return menu;
        }
        if (get === 'consentMenu') {
          return consentMenu;
        }
        if (get === 'connectorData') {
          return connectorDataConsent;
        }
        if (connectorTypes[get]) {
          return this.$store.state[type].find(
            connector => connector.data.subscriptionDetails.SOURCE_ID === get
          );
        }
      }
      return availableNames[connectorTypes[connectorType]];
    },
    initalRoute(type) {
      if (this.$route.path === '/' || type === 'GO_TO_INITAL') {
        if (this.$can('manage', 'dashboard')) {
          return this.$router.replace({ path: '/dashboard/monitoring' });
        } else {
          return this.$router.replace({
            path: '/archive-search/email/inbox/p1'
          });
        }
      }
    },
    openProjectTab(projectRow, redirect = false, projectType) {
      /*
        update the open project array in store
        it will automatically update the tabs
      */
      let openProjects = this.getOpenProjects();
      let projectIndex = openProjects.findIndex(
        project => project.projectSlug === projectRow.projectSlug
      );

      if (projectIndex === -1) {
        /*
          means project is not open
          push to store and redirect user to page
        */

        openProjects.push({
          projectSlug: projectRow.projectSlug,
          projectName: projectRow.projectName,
          projectStatus: projectRow.projectStatus
        });
        this.setOpenProjects(openProjects);
      }
      let path = `/discovery/projects/${projectRow.projectSlug}`;
      if (redirect) {
        if (projectType === 'archivedProjects') {
          path = `${path}/archives`;
        }
        this.$router.push({ path });
      }
    },
    phoneNumberValidation({ number, isValid }) {
      if (number.input === '') {
        this.telClass = '';
      } else {
        if (isValid) {
          this.telClass = 'is-valid';
        } else {
          this.telClass = 'is-invalid';
        }
      }
    },
    sanitize(html) {
      return sanitizeHtml(html, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
          'title',
          'img',
          'iframe',
          'p',
          'at',
          'table',
          'tr',
          'td',
          'th'
        ]),
        allowedAttributes: {
          iframe: ['id', 'height', 'width'],
          img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
          a: ['href', 'name', 'target'],
          at: ['name'],
          '*': [
            'style',
            'align',
            'cellpadding',
            'cellspacing',
            'width',
            'id',
            'valign',
            'class'
          ]
        },
        allowedSchemes: ['data', 'http', 'https'],
        transformTags: {
          at: function() {
            // My own custom html transformations goes here
            return {
              tagName: 'span',
              attribs: {
                class: 'at'
              }
            };
          }
        }
      });
    },
    async getTimezone() {
      try {
        let response = await this.$services.preferences.getPreferencesByPreferenceKey(
          this.$preference.TIMEZONE
        );
        let parsedResponse = this.parseResponse(response);
        if (parsedResponse !== false) {
          const source = parsedResponse[0].results[0].data.timezone;

          const timezoneId = parsedResponse[0].results[0].id;
          this.setCurrentTimeZone({ source, timezoneId });
        } else {
          this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
        }
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    parseResponse(response) {
      if (!response) {
        return false;
      }
      if (!response.data) {
        return false;
      }
      if (response.data.success) {
        return response.data.body;
      }
      return false;
    },
    formatuserListForFullName(listToFormat) {
      let formattedList = listToFormat.map(user => {
        user['fullName'] = this.formatFullName(user);
        return user;
      });
      return formattedList;
    },
    getPageRecordFromToIndex(pageNumber, pageSize, listLength) {
      if (listLength === 0) {
        return false;
      }
      return {
        from: (pageNumber - 1) * pageSize + 1,
        to: (pageNumber - 1) * pageSize + listLength
      };
    },
    removeFromArray(arr, what) {
      var a = arguments,
        L = a.length,
        ax;
      while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1);
        }
      }
      return arr;
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    },
    isOwnOrgSelected() {
      return this.orgId === this.currentlySelectedOrgId;
    },
    // Getting sender name by checking 'external' field
    // If :- external = false, check userId in userIdNameMap
    // Else ;- return sender name/email details, don't explore userIdNameMap
    getMessageSenderName({ name, userId, external: isExternalUser, email }) {
      let senderName = name || email || 'External User';

      // If external user then place a label to distinguish
      if (isExternalUser) {
        return `${senderName} ${
          senderName !== 'External User' ? '(External)' : ''
        }`;
      }
      senderName =
        this.formatUserName(this.userIdNameMap[userId]) || senderName;
      return senderName;
    },
    async logoutUser() {
      try {
        // delete client
        await this.$services.notification.deleteClient(
          this.$store.state.notifications.objNotiToken.id
        );
        // set token object to empty in store
        this.setNotiClientToken({});
      } catch (err) {
        // error logging out
      } finally {
        let selectedTheme = localStorage.getItem('selectedTheme');
        localStorage.clear();
        localStorage.setItem('selectedTheme', selectedTheme);
        this.setNotiClientToken({});
        this.$keycloak.logout({ redirectUri: config.baseUrl });
        this.$keycloak.onAuthLogout = () => {
          this.setOpenProjects([]);
        };
      }
    }
  },

  computed: {
    portalLink() {
      return process.env.VUE_APP_MAILSPHERE;
    },
    ...mapState({
      userIdNameMap: state => state.userInfo.userIdNameMap
    }),
    ...mapState([
      'subscriptions',
      'currentSubscription',
      'onboardingStatus',
      'isCurrentOrgLegacy',
      'orgId',
      'currentlySelectedOrgId',
      'userInformation'
    ]),
    /**
     * To check that is dropbox feature accessible
     *
     * Condition 1:- Dropbox will be accessible only when org have permission can_view_dropbox
     * Condition 2:- Either legacy org or org with non-trial plans
     * @returns true if dropbox accessible else false
     */
    isDropboxAccessible() {
      return (
        this.$can('view', 'dropbox') &&
        (this.currentSubscription?.product?.handle !== 'trial' ||
          this.isCurrentOrgLegacy)
      );
    }
  }
};
